<script>
  import { push } from "svelte-spa-router"
  import Navbar from "../../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../../Shared/footer.svelte"
  import InvalidCells from "../../Modules/invalidCellsAccordion/index.svelte"
</script>

<svelte:head>
  <title>Bulk Upload</title>
</svelte:head>

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] pb-24 dark:bg-bodyblack">
  <Navbar />

  <div class="flex px-6 pb-12 pt-9">
    <div class="relative mx-auto flex w-full max-w-[920px] flex-col rounded-md">
      <button
        on:click={() => {
          push("/publish/bulk")
        }}
        type="button"
        class="mb-3 block w-16 cursor-pointer select-none text-base font-medium text-gray-200 hover:text-blue-600 focus-visible:text-blue-600 focus-visible:outline-none active:text-blue-500"
        style="text-decoration: none;"
      >
        <span>
          <i class="fa-solid fa-reply" />
          <span>&nbsp;Back&nbsp;</span>
        </span>
      </button>
      <div>
        <InvalidCells />
      </div>
    </div>
  </div>

  <Footer />
</div>
